module.exports = __webpack_public_path__ + "img/northeast-fall-768x550.6a38160f.jpg";